export default __webpack_public_path__ + "static/media/Space_object_ghoul.3331d444.gif";